/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StoreDataState {
  [key: string]: any; // allows number, string, array, object, etc.
}

const initialState: StoreDataState = {};

const storeDataSlice = createSlice({
  name: "storeData",
  initialState,
  reducers: {
    setData: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      state[action.payload.key] = action.payload.value;
    },
    removeData: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
    clearData: () => {
      return {};
    },
  },
});

export const { setData, removeData, clearData } = storeDataSlice.actions;
export default storeDataSlice.reducer;
